/**
 * The IC/M ladder, on its own.
 *
 * Split out of demandUi.tsx because the SHAPING half needs it — members are
 * sorted by level — and demandUi imports from demandModel, so leaving it there
 * made the two files import each other. A ladder is data, not a component.
 */
export const LEVELS = ['IC0', 'IC1', 'IC2', 'IC3', 'IC4', 'IC5', 'M4', 'M5', 'M6', 'M7'];

/**
 * Where a level sits on the ladder. Two things read it and they must agree: the
 * order people are listed in, and what one step down from a role means.
 *
 * An unrecognised level sorts LAST rather than first — a blank is not junior,
 * it is unknown, and putting unknowns at the top of a team list would bury the
 * juniors the order exists to show.
 */
export const levelRank = (level: string | undefined): number => {
  const i = LEVELS.indexOf(String(level ?? '').trim().toUpperCase());
  return i === -1 ? LEVELS.length : i;
};

/**
 * One step down the ladder, for a backfill's default.
 *
 * A backfill is very rarely hired at the level of the person leaving — the seat
 * is re-opened one step down and grows back — so that is the default, and it is
 * a default: the row's own level picker edits it. IC0 has nowhere to go.
 */
export const oneLevelDown = (level: string | undefined): string => {
  const i = LEVELS.indexOf(String(level ?? '').trim().toUpperCase());
  if (i <= 0) return LEVELS[0];
  return LEVELS[i - 1];
};

